module.exports = __webpack_public_path__ + "img/jiaotong.5b349d33.png";